import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { c } from "./index-65016bfa.mjs";
import { styled as o } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as a } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
const h = o.div`
  display: ${(t) => t.theme.components.slot.SlotWrapper.display};
  padding: ${(t) => t.theme.components.slot.SlotWrapper.padding};
  flex-direction: ${(t) => t.theme.components.slot.SlotWrapper.flexDirection};
  justify-content: ${(t) => t.theme.components.slot.SlotWrapper.justifyContent};
  align-items: ${(t) => t.theme.components.slot.SlotWrapper.alignItems};
  border: ${(t) => t.theme.components.slot.SlotWrapper.border};
  background: ${(t) => t.theme.components.slot.SlotWrapper.background};
  height: ${({ height: t }) => t};
  box-sizing: ${(t) => t.theme.components.slot.SlotWrapper.boxSizing};
  width: ${({ width: t }) => t};
  box-sizing: ${(t) => t.theme.components.slot.SlotWrapper.boxSizing};
`, S = o.span`
  color: ${(t) => t.theme.components.slot.SlotTitle.color};
  text-align: ${(t) => t.theme.components.slot.SlotTitle.textAlign};
  font-family: ${(t) => t.theme.components.slot.SlotTitle.fontFamily};
  font-size: ${(t) => t.theme.components.slot.SlotTitle.fontSize};
  font-style: ${(t) => t.theme.components.slot.SlotTitle.fontStyle};
  font-weight: ${(t) => t.theme.components.slot.SlotTitle.fontWeight};
  line-height: ${(t) => t.theme.components.slot.SlotTitle.lineHeight};
`, d = o.span`
  color: ${(t) => t.theme.components.slot.SlotPlaceHolder.color};
  text-align: ${(t) => t.theme.components.slot.SlotPlaceHolder.textAlign};
  font-family: ${(t) => t.theme.components.slot.SlotPlaceHolder.fontFamily};
  font-size: ${(t) => t.theme.components.slot.SlotPlaceHolder.fontSize};
  font-style: ${(t) => t.theme.components.slot.SlotPlaceHolder.fontStyle};
  font-weight: ${(t) => t.theme.components.slot.SlotPlaceHolder.fontWeight};
  line-height: ${(t) => t.theme.components.slot.SlotPlaceHolder.lineHeight};
`, P = ({
  title: t = "Slot",
  placeHolder: l = "This is a placeholder swap me",
  height: n = "auto",
  width: s = "auto",
  className: i,
  ...m
}) => {
  const p = a({ label: "Slot" });
  return /* @__PURE__ */ r(
    h,
    {
      height: n,
      width: s,
      className: c(["Slot", i]),
      ...m,
      ...p,
      children: [
        /* @__PURE__ */ e(S, { children: t }),
        /* @__PURE__ */ e(d, { children: l })
      ]
    }
  );
};
export {
  P as Slot
};
